module.exports = __webpack_public_path__ + "img/client-7--small.png?08add1ad7551b5ab21b93dce1045108a";